const normalizeInitialHiddenColumnsState = (value, columns) => {
  return Object.fromEntries(Array.from(columns.entries(), ([i, col]) => [i, value?.[i] ?? col.hidden ?? false]));
};
export {
  normalizeInitialHiddenColumnsState
};
//# sourceMappingURL=normalizeInitialHiddenColumnsState.js.map
